import * as Yup from "yup";

import { Card, Col, Row } from "@themesberg/react-bootstrap";
import { ErrorMessage, Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import {
  getAllDataOfDispenserSrNo,
  // getDataScannedOrNot,
  // getDataScannedOrNotinstallation,
  // getInstallationDetailsGetData,
  postInstallation,
} from "../../Service/AllServicesAPI";
import {
  getCustomerList,
  getDealerList,
  getServiceEngineerList,
} from "../master/AllUserDropDown";

import DatePicker from "react-datepicker";
import { Link } from "react-router-dom";
import NotScanned from "../NotScanned";
import Swal from "sweetalert2";
import { faAlignLeft, faAngleLeft, faBackward } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import TextError from "../TextError";
import ToolTip from "../ToolTip";
import Webcam from "react-webcam";
import moment from "moment-timezone";
import swal from "sweetalert";
import { useHistory, useLocation } from "react-router-dom";

export default () => {
  const [show, setShow] = useState(false);
  const [customerName, setCustomerName] = useState([]);
  const [csd, setCsd] = useState([1]);
  const [mre, setMre] = useState([1]);
  const [lkd, setLkd] = useState([1]);

  // newly added board vr and printer
  const [pvr, setPvr] = useState([1]);
  const [prn, setPrn] = useState([1]);
  // close installation button disable
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  // image validation to keep image disabled
  const [iscalibrationstartcloseEnables, setButtonDisabled] = useState(true);

  const history = useHistory();
  const location = useLocation();
  const [workOrder, setWorkOrder] = useState("");
  const [role, setRole] = useState(sessionStorage.getItem("role"));
  const [processData, setProcessData] = useState([]);
  const [dispenserSrNo, setDispenserSrNo] = useState("");
  const [dealerName, setDealerName] = useState([]);
  const [customerNm, setCustomerNm] = useState("");
  const [customerMblNo, setCustomerMblNo] = useState("");
  const [serviceEngineerNm, setServiceEngineerNm] = useState("");
  const [fkCustomer, setfkCustomer] = useState("");
  const [fkDealer, setfkDealer] = useState("");
  const [SerEngineerId, setfkSerEngineerId] = useState("");
  const [userMblNo, setUserMblNo] = useState("");
  const [dealerNm, setDealerNm] = useState("");
  const [dealerMblNo, setDealerMblNo] = useState("");
  const [siteType, setSiteType] = useState("");
  const [serviceEngineerName, setServiceEngineerName] = useState([]);
  const [curreLocation, setCurreLocation] = useState({});
  const [isLoaded, setisLoaded] = useState(false);
  const [prodT, setProdT] = useState("");
  const [showForm, setShowForm] = useState(true);
  const [selectedTime, setSelectedTime] = useState("");
  const [startDate, setStartDate] = useState("");
  const [base64Image, setBase64Image] = useState("");
  const [uploadedImage, setUploadedImage] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [imageName, setImageName] = useState("");
  const [disabled, setdisabled] = useState(false);
  const [roManagerName,setroManagerName]=useState("");
  const [fkRoManagerId,setfkRoManagerId]= useState("");
  const [roManagerEmail,setroManagerEmail]=useState("");
  const [roManagerMobNo,setroManagerMobNo]=useState("");
  const [Instalationphotoupload, SetInstalationphotoupload] = useState('');

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const formatTimeTo12Hour = (time24) => {
    const [hour, minute, second] = time24.split(":");
    const parsedHour = parseInt(hour, 10);
    const period = parsedHour >= 12 ? "PM" : "AM";
    const formattedHour = parsedHour > 12 ? parsedHour - 12 : parsedHour;
    return `${formattedHour}:${minute}:${second} ${period}`;
  };

  const displayFormattedTime = selectedTime
    ? formatTimeTo12Hour(selectedTime)
    : "";

  const getPassedData = () => {
    if (location.state && location.state.data) {
      sessionStorage.setItem("getDispenserData", JSON.stringify(location.state.data));
      return location.state.data;
    }
    const saved = sessionStorage.getItem("getDispenserData");
    if (saved) {
      try {
        return JSON.parse(saved);
      } catch (e) {
        return null;
      }
    }
    return null;
  };

  useEffect(() => {
    if (role === "service engineer") {
      const data = getPassedData();
      if (data) {
        console.log("GetDispenser data :-", data);
        setWorkOrder(data.workOrderSerialNo);
        setDispenserSrNo(data.generateUniqueDispenserNo);
        setCustomerNm(data.customerName); //siteType
        setCustomerMblNo(data.customerMobNo);
        setServiceEngineerNm(data.serviceEngineerName);
        setfkCustomer(data.fkCustomerId);
        setfkDealer(data.fkDealerId);
        setfkSerEngineerId(data.fkServiceEngineerId);
        setUserMblNo(data.serviceEngineerMobNo);
        setDealerNm(data.dealerName);
        setDealerMblNo(data.dealerMobNo);
        setSiteType(data.siteType);
        setroManagerName(data.roManagerName);
        setroManagerEmail(data.roManagerEmail);
        setroManagerMobNo(data.roManagerMobNo);
        setfkRoManagerId(data.fkRoManagerId);
      }
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", function (event) {
      if (event.keyCode === 13 && event.target.nodeName === "INPUT") {
        var form = event.target.form;
        var index = Array.prototype.indexOf.call(form, event.target);
        form.elements[index + 1].focus();
        event.preventDefault();
      }
    });
  }, []);

  useEffect(() => {
    // Function call to get customers,Dealers and  Service Engineers list
    getCustomersList();
    getServiceEngineersList();
    getDealersList();
    if (role === "service engineer") {
      const data = getPassedData();
      if (data && data.generateUniqueDispenserNo) {
        // getDataScanOrNot(data.generateUniqueDispenserNo);
        getAllDataOfDispenSrNo(data.generateUniqueDispenserNo);
      }
    }
  }, []);

  // Function declaration of get customers list
  const getCustomersList = async () => {
    await getCustomerList().then((result) => {
      setCustomerName(result);
    });
  };

  // Function declaration of get Service Engineers list
  const getServiceEngineersList = async () => {
    await getServiceEngineerList().then((result) => {
      setServiceEngineerName(result);
    });
  };
  // Function declaration of get Dealer list
  const getDealersList = async () => {
    await getDealerList().then((result) => {
      setDealerName(result);
    });
  };

  const alertMessage = () => {
    Swal.fire({
      position: "top-center",
      title: "Please Scan the device and get the data from the dispenser",
      showConfirmButton: false,
      timer: 3000,
    });
  };


  const getAllDataOfDispenSrNo = (disSrNo) => {
    const token = sessionStorage.getItem("token");
    const headers = { Authorization: `Bearer ${token}` };
    console.log("dispenserSrNo :-", disSrNo);
    getAllDataOfDispenserSrNo(disSrNo, headers)
      .then((result) => {
        console.log("getAllDataOfDispenSrNo result sab :-", result);
        setProdT(result.data.productType);
      })
      .catch((error) => {
        console.log("getAllDataOfDispenSrNo error :-", error);
      });
  };

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition, showError);
    }
  }, []);

  const showPosition = (position) => {
    console.log("position :-", position);
    const { latitude, longitude } = position.coords;
    console.log("latitude, longitude :-", latitude, longitude);
    setCurreLocation({ latitude, longitude });
  };

  const showError = (error) => {
    // swal(
    //   "Failed",
    //   "Geolocation is not supported in your browser enable it from browser setting",
    //   "warning"
    // );
    console.log("showError error :-", error);
  };

  // const validationSchema = Yup.object().shape({
  //   uploadDispenserPhoto: Yup.mixed()
  //     .required("Image is required")
  //     .test("is-image", "Only image files are allowed", (value) => {
  //       if (!value) return false;
  //       return (
  //         value &&
  //         [
  //           "image/jpeg",
  //           "image/png",
  //           "image/gif",
  //           "image/webp",
  //           "image/jpg",
  //         ].includes(value.type)
  //       );
  //     }),
  // });


  const validationSchema = Yup.object().shape({
    uploadDispenserPhoto: Yup.mixed()
      .required("Image is required")
      .test("fileSize", "Image size should be less than 18 KB", (value) => {
        if (!value) return false;
        return value.size / 1024 <= 188; // Convert bytes to KB
      })
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return ["image/jpeg", "image/png", "image/gif", "image/webp", "image/jpg"].includes(value.type);
      }),
    uploadDispenserPhoto: Yup.mixed()
      .required("Image is required")
      .test("is-image", "Only image files are allowed", (value) => {
        if (!value) return false;
        return (
          value &&
          [
            "image/jpeg",
            "image/png",
            "image/gif",
            "image/webp",
            "image/jpg",
          ].includes(value.type)
        );
      }),
    siteAddress: Yup.string().required("Required *"),
  });


  // Added new boards in modelQty (prn and pvr)  with other boards (csd,mre,lkd) and (Mcu,Tot)
  const modelQty = [
    {
      modelNo: "1111",
      csd: [1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },
    {
      modelNo: "1121",
      csd: [1, 1],
      mre: [1],
      lkd: [1],
      prn: [1],
      pvr: [1],
    },
    {
      modelNo: "1222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2222",
      csd: [1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2422",
      csd: [1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3622",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4822",
      csd: [1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2242",
      csd: [1, 1, 1, 1],
      mre: [1, 1],
      lkd: [1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "1444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "2444",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "3644",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
    {
      modelNo: "4844",
      csd: [1, 1, 1, 1],
      mre: [1, 1, 1, 1, 1, 1, 1, 1],
      lkd: [1, 1, 1, 1],
      prn: [1, 1],
      pvr: [1],
    },
  ];

  // const uploadImg = (e) => {
  //   console.log("uploadImg :-", e.target.files[0]);
  //   const file = e.target.files[0];

  //   console.log("file :-", file);
  //   if (file) {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setBase64Image(reader.result);
  //       setImageName(file.name);
  //     };
  //     reader.readAsDataURL(file);
  //     setUploadedImage(file);
  //   }
  // };

  const uploadImg = (e) => {
    console.log("uploadImg :-", e.target.files[0]);
    const file = e.target.files[0];
    console.log("file :-", file);

    if (file) {

      if (!file.type.startsWith('image/')) {

        SetInstalationphotoupload("Please upload an image file.");
        setButtonDisabled(true);
        return;
      }


      if (file.size > 100 * 1024) {

        SetInstalationphotoupload(
          <p>
            The selected image size exceeds 100 KB. Please reduce the size of the image using this link:{" "}
            <a href="https://image.pi7.org/reduce-image-size-in-kb" target="_blank">
              <span style={{ color: 'blue', textDecoration: 'none' }}>https://image.pi7.org/reduce-image-size-in-kb</span>
            </a>.
          </p>
        );
        setButtonDisabled(true);
        return;
      }


      const reader = new FileReader();
      reader.onload = () => {
        setBase64Image(reader.result);
        setButtonDisabled(false);
      };
      reader.readAsDataURL(file);
      setUploadedImage(file);
    }
  };


  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
      reader.readAsDataURL(file);
    });
  };

  return (
    <Formik
      initialValues={{
        workOrderNo: "",
        productType: "",
        generateUniqueDispenserNo: "",
        siteType: "",
        fkServiceEngineerId: "",
        serviceEngineerName: "",
        serviceEngineerMobNo: "",
        fkCustomerId: "",
        customerName: "",
        customerMobileNo: "",
        fkDealerId: "",
        dealerName: "",
        dealerMobileNo: "",
        siteAddress: "",
        uploadDispenserPhoto: "",
        installationDate: "",
        installationTime: "",
        longitude: "",
        latitude: "",
        roManagerName:"",
        roManagerMobNo:"",
        roManagerEmail:"",
        fkRoManagerId  :"",

      }}
      validationSchema={validationSchema}
      onSubmit={async (values) => {
        try {
          // code that we will 'try' to run
          let pkUserId = sessionStorage.getItem("pkUserId");
          let data = {
            workOrderNo: workOrder,
            productType: prodT,
            generateUniqueDispenserNo: dispenserSrNo,
            siteType: siteType,
            fkServiceEngineerId: SerEngineerId,
            serviceEngineerName: serviceEngineerNm,
            serviceEngineerMobNo: userMblNo,
            fkCustomerId: fkCustomer,
            customerName: customerNm,
            customerMobileNo: customerMblNo,
            fkDealerId: fkDealer,
            dealerName: dealerNm,
            dealerMobileNo: dealerMblNo,
            roManagerEmail:roManagerEmail,
            roManagerMobNo:roManagerMobNo,
            roManagerName:roManagerName,
            fkRoManagerId  :fkRoManagerId,
            siteAddress: values.siteAddress,
            uploadDispenserPhoto: base64Image,
            // longitude: curreLocation.longitude,
            // latitude: curreLocation.latitude,
            installationDate: moment(startDate, "yyyy-MM-DD").format(
              "yyyy-MM-DD"
            ),
            installationTime: moment(displayFormattedTime, "hh:mm:ss A").format(
              "hh:mm:ss A"
            ),
            longitude: curreLocation.longitude,
            latitude: curreLocation.latitude,
          };
          console.log("Get Dispenser data :-", data);
          const token = sessionStorage.getItem("token");
          const headers = { Authorization: `Bearer ${token}` };
          
          await postInstallation(data, headers)
            .then((result) => {
              console.log("Add Installation result :-", result);
              setisLoaded(false);

              const message = result.data.message;

              if (message === "installation details added successfully") {
                swal("Great", "Installation details added successfully", "success");
                setIsButtonDisabled(true);
                setTimeout(() => {
                  window.location.href = "serviceModule/verification-installation-list";
                }, 7000);
              } else if (message === "Dublicate workOrder Number") {
                swal("Failed", "Duplicate work order number", "warning");
              } else if (message === "dispenser data is not scaned for this work order installation 1" ||
                message === "dispenser data is not scaned for this work order installation 2" ||
                message === "Dispenser data is not scaned for this work order installation 3") {
                swal("Failed", "Dispenser data is not scanned for this work order installation", "warning");

              } else if (message === "PKI Server is down..") {
                swal("Failed", "PKI Server is down", "error");
              } else if (message === "Customer Name is Not Valid") {
                swal("Failed", "Customer Name is not valid", "warning");
              } else if (message === "Bord scerial Number Not Varifide") {
                swal("Failed", "Board serial number not verified", "warning");
              } else if (message === "Work order No is Not Valid") {
                swal("Failed", "Work order number is not valid", "warning");
              } else {
                swal("Failed", "Installation Failed", "error");
              }
              setIsButtonDisabled(true);
               setTimeout(() => {
                  window.location.href = "serviceModule/verification-installation-list";
                }, 7000);
              // window.location.href = '/serviceModule/verification-installation-list';
          
              
            })
            .catch((error) => {
              console.log("Installation Error :-", error);
              setisLoaded(false);

              if (error.response.data.status === 400) {
                swal("Failed", `${error.response.data.message}`, "warning");
              } else if (error.response.data.status === 500) {
                swal("Failed", `${error.response.data.message}`, "error");
              } else {
                swal("Failed", "Installation Failed", "error");
              }
            });
        } catch (error) {
          console.log(error);
          swal("Failed", "Something went wrong, please check your internet connection", "error");
        }
      }}
    >
      {(formik) => {
        const { isValid, dirty, isSubmitting, values } = formik;
        const isfieldjobButtonEnabled = startDate && displayFormattedTime && values.siteAddress && values.uploadDispenserPhoto;
        return (
          <>
            <div className="d-flex mb-2">
              <Link
                to="verification-installation-list"
                className="fieldLink btn btn-primary"
              >
                <FontAwesomeIcon icon={faAngleLeft} className="me-2" />{" "}
                My Jobs
                <span className="icon icon-small ms-1"></span>
              </Link>
            </div>
            <Card border="light" className="bg-white shadow-sm mb-4">
              <Card.Body>
                {showForm ? (
                  <>
                    <h5 className="head mb-4">Submit Installation</h5>
                    <Form>
                      <Row>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Work Order No.{" "}
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="workOrderNo"
                              placeholder="Work Order No."
                              value={workOrder}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Dispenser Serial No
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              name="generateUniqueDispenserNo"
                              placeholder="Dispenser Serial No."
                              value={dispenserSrNo}
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Product Type</label>
                            <Field
                              placeholder="Select Product Type"
                              value={prodT}
                              className="form-control"
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Site Type</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Select Site Type"
                              readOnly
                              value={siteType}
                            />
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> RO Manager Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="ro Manager Name"
                              readOnly
                              value={roManagerName}
                            />
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> Ro Manager Email</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Ro Manager Email"
                              readOnly
                              value={roManagerEmail}
                            />
                          </div>
                        </Col>

                         <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Ro Manager Mobile Number</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Ro Manager Mobile"
                              readOnly
                              value={roManagerMobNo}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1"> Customer Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Customer Name"
                              readOnly
                              value={customerNm}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Customer Mobile No
                            </label>
                            <Field
                              type="text"
                              maxLength="10"
                              name="customerMobileNo"
                              value={customerMblNo}
                              className="form-control"
                              placeholder="Customer Mobile No"
                              readOnly
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Service Engineer Name
                            </label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Service Engineer Name"
                              readOnly
                              value={serviceEngineerNm}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Service Engineer Mobile No
                            </label>
                            <Field
                              type="text"
                              maxLength="10"
                              className="form-control"
                              name="serviceEngineerMobNo"
                              value={userMblNo}
                              placeholder="Mobile No."
                              readOnly
                            />
                          </div>
                        </Col>
                        {!(siteType === "COCO") && (
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">Dealer Name</label>
                            <Field
                              type="text"
                              className="form-control"
                              placeholder="Dealer Name "
                              value={dealerNm}
                              readOnly
                            />
                          </div>
                        </Col>
                        )}
                          {!(siteType === "COCO") && (
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="Label mb-1">
                              {" "}
                              Dealer Mobile No{" "}
                            </label>
                            <Field
                              type="text"
                              maxLength="10"
                              name="dealerMobileNo"
                              value={dealerMblNo}
                              className="form-control"
                              placeholder="Dealer Mobile No"
                              readOnly
                            />
                          </div>
                        </Col>
                          )}
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Site Address *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Enter Address"
                                direction="bottom"
                              >
                                <Field
                                  type="text"
                                  className="form-control"
                                  name="siteAddress"
                                  placeholder="Site Address"
                                  autoComplete="off"

                                />
                              </ToolTip>
                            </div>
                            <ErrorMessage
                              name="siteAddress"
                              component={TextError}
                            />
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Site Photo *{" "}
                            </label>
                            <div className="example-wrapper">
                              <ToolTip
                                content="Add Site Photo"
                                direction="bottom"
                              >
                                <input
                                  type="file"
                                  className="form-control"
                                  name="uploadDispenserPhoto"
                                  placeholder="Site Photo"
                                  accept=".jpg, .jpeg, .png"
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      "uploadDispenserPhoto",
                                      e.currentTarget.files[0]
                                    );
                                    SetInstalationphotoupload('')
                                    uploadImg(e);
                                  }}
                                />
                              </ToolTip>
                            </div>
                            {/* <ErrorMessage
                              name="uploadDispenserPhoto"
                              component={TextError}
                            /> */}
                            {Instalationphotoupload && <p className="text-danger">{Instalationphotoupload}</p>}

                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Installation Date *{" "}
                            </label>
                            <br />
                            <div className="example-wrapper">
                              <ToolTip content="Select Date" direction="bottom">
                                <DatePicker
                                  showIcon
                                  closeOnScroll={true}
                                  selected={startDate}
                                  onChange={(date) => setStartDate(date)}
                                  className="form-control"
                                  dateFormat="dd-MMM-yyyy"
                                  placeholderText="Select Date"
                                  
                                />
                              </ToolTip>
                            </div>
                          </div>
                        </Col>
                        <Col md={6} className="mb-3">
                          <div className="form-group">
                            <label className="LabelNew mb-1">
                              {" "}
                              Installation Time *{" "}
                            </label>
                            <br />
                            <div className="time-wrapper">
                              <div className="allTime">
                                <input
                                  type="time"
                                  onChange={handleTimeChange}
                                  className="form-control"
                                  step="1"
                                />
                              </div>
                              <div className="addTime">
                                <div className="example-wrapper">
                                  <ToolTip
                                    content="Select Time from Widget"
                                    direction="bottom"
                                  >
                                    <Field
                                      className="form-control"
                                      name="installationTime"
                                      placeholder="Select Time from Widget"
                                      value={displayFormattedTime}
                                      readOnly
                                    />
                                  </ToolTip>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                      <button
                        type="submit"
                        className="btn btn-primary mr-4"
                        disabled={!isfieldjobButtonEnabled || iscalibrationstartcloseEnables || isButtonDisabled}
                      >
                        Submit Installation{" "}
                      </button>
                      {/* <h5 className="note">
                        Note :- Please scan the device and get the data from
                        dispenser.
                      </h5> */}

                      {/* ---------------------------------------------------------------- show dispenser data
        ---------------------------------------------------------------- */}
                      <div className="main-form">
                        {/* //{show && Hide*/}
                        {show ? (
                          <Form>
                            <hr />
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Model Name
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.modelName}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            <h5 style={{ textAlign: "left", color: "#004417" }}>
                              Motherboard (MCU)
                            </h5>
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Firmware Version No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardSoftwareSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Hardware Version{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardHardwareVersion}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Serial No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.mcuBoardSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">SHA2</label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardSHA2}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Sign X-509-64 Bit Block{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardSignXBitBlock}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Private Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardPrivateKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    RCA Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.mcuBoardRCAPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            <hr />
                            <h5 style={{ textAlign: "left", color: "#004417" }}>
                              Totalizer (TOT)
                            </h5>
                            <Row>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Firmware Version No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1SoftwareSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Hardware Version{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1HardwareVersion}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Serial No{" "}
                                  </label>
                                  <Field
                                    type="text"
                                    className="form-control"
                                    value={processData.memBoard1BoardSrNo}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">SHA2</label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1BoardSHA2}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Sign X-509-64 Bit Block{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1SignXBitBlock}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1PublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    Board Private Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData.memBoard1PrivateKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                              <Col md={4} className="mb-3">
                                <div className="form-group">
                                  <label className="Label mb-1">
                                    {" "}
                                    RCA Public Key{" "}
                                  </label>
                                  <Field
                                    type="password"
                                    className="form-control"
                                    value={processData?.memBoard1RCAPublicKey}
                                    readOnly
                                  />
                                </div>
                              </Col>
                            </Row>
                            {csd.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Customer Display (CSD-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`csd${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`csd${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `csd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {mre.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "#004417",
                                  }}
                                >
                                  Pulser (MRE-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`mre${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`mre${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `mre${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {lkd.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "#004417",
                                  }}
                                >
                                  Operator Keypad Display (LKD-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`lkd${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`lkd${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `lkd${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {/* ---------------------------------------------------------------- Vapor Recovery (VR) */}
                            {pvr.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Vapor Recovery (VR-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`pvr${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`pvr${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `pvr${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                            {/* ---------------------------------------------------------------- Operator Keypad Display (Printer) */}
                            {prn.map((obj, key) => (
                              <div key={key}>
                                <hr />
                                <h5
                                  style={{
                                    textAlign: "left",
                                    color: "darkblue",
                                  }}
                                >
                                  Printer (Printer-{key + 1})
                                </h5>
                                <Row>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Firmware Version No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardSoftwareSrNo`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Hardware Version{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardHardwareVersion`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Serial No{" "}
                                      </label>
                                      <Field
                                        type="text"
                                        className="form-control"
                                        value={
                                          processData[`prn${key + 1}BoardSrNo`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">SHA2</label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[`prn${key + 1}BoardSHA2`]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Sign X-509-64 Bit Block{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardSignXBitBlock`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        Board Private Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardPrivateKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                  <Col md={4} className="mb-3">
                                    <div className="form-group">
                                      <label className="Label mb-1">
                                        {" "}
                                        RCA Public Key{" "}
                                      </label>
                                      <Field
                                        type="password"
                                        className="form-control"
                                        value={
                                          processData[
                                          `prn${key + 1}BoardRCAPublicKey`
                                          ]
                                        }
                                        readOnly
                                      />
                                    </div>
                                  </Col>
                                </Row>
                              </div>
                            ))}
                          </Form>
                        ) : (
                          <></>
                        )}
                      </div>
                    </Form>
                  </>
                ) : (
                  <NotScanned />
                )}
              </Card.Body>
            </Card>
          </>
        );
      }}
    </Formik>
  );
};
